const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    width: "600px",
    transform: "translate(-50%, -50%)"
  }
};

export default customStyles;
